import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaInput } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { useToaster } from "utils";

export interface SmtpSettingsFormProps {
  host: string;
  port: string;
  username: string;
  fromEmail: string;
  fromName: string;
}

export const SmtpSettingsForm = ({ host, port, username, fromEmail, fromName }: SmtpSettingsFormProps) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      host,
      port: port ? Number(port) : undefined,
      username,
      fromEmail,
      fromName,
      password: "",
    },
  });

  const onSubmit = async (values: SmtpSettingsValues) => {
    try {
      await settingsApi.saveSmtp({ ...values, password: values.password || undefined });
      await invalidateSettings();
      showSuccess("Zapisano ustawienia SMTP");
    } catch (error) {
      showError("Błąd podczas zapisywania ustawień SMTP");
    }
  };

  const {
    handleSubmit,
    formState: { isDirty, errors },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
        <PaziaInput label="Host SMTP" name="host" />
        <PaziaInput label="Port SMTP" name="port" type="number" />
        <PaziaInput label="Login SMTP" name="username" />
        <PaziaInput label="Adres email nadawcy" name="fromEmail" />
        <PaziaInput label="Nazwa nadawcy" name="fromName" />
        <PaziaInput
          label="Hasło SMTP"
          name="password"
          type="password"
          placeholder="Pozostaw puste, aby nie zmieniać"
        />
        <div>
          <PaziaButton
            type="success"
            disabled={!isDirty}
            title="Zapisz"
            className={Object.keys(errors).length ? "mb-[26px]" : ""}
          />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    host: yup.string().required(),
    port: yup.number().required(),
    username: yup.string().required(),
    fromEmail: yup.string().email().required(),
    fromName: yup.string().required(),
    password: yup.string().optional(),
  })
  .required();

export type SmtpSettingsValues = yup.InferType<typeof schema>;
